import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getSlackConfigurationsQueryKey } from 'hooks/queries/notifications/useGetSlackConfigurations';

export const useDeleteSlackConfiguration = (
  onSuccess?: () => void,
  onError?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => {
      return apiClient.notifications.deleteSlackConfiguration({ id });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: getSlackConfigurationsQueryKey() })
        .then(() => {
          notify.success('Slack configuration deleted successfully');
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
      onError?.();
    },
  });
};
